export const isMobileQuery = '(max-width: 768px)'
